<template>
    <section class="hero has-background-pale-grey is-large">
        <div class="hero-body py-6">
            <div class="container has-text-centered">
                <h1
                    v-t="'Home.register_as_school'"
                    class="title is-4 has-text-weight-bold"
                ></h1>
                <div class="columns is-centered">
                    <div class="column is-3">
                        <figure class="image">
                            <img
                                src="@/assets/images/dashboard-header-image.png"
                                srcset="
                                    @/assets/images/dashboard-header-image@2x.png 2x,
                                    @/assets/images/dashboard-header-image@3x.png 3x
                                "
                            />
                        </figure>
                    </div>
                    <div class="column is-2"></div>
                    <div class="column is-4">
                        <p
                            v-t="'Home.school_description'"
                            class="pt-6 has-text-left-tablet"
                        ></p>
                        <router-link
                            v-t="'Home.go_to_explorer'"
                            :to="'explore'"
                            tag="button"
                            class="lb-button mt-4 is-primary is-uppercase"
                        ></router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns is-centered pb-6">
            <div class="column is-3">
                <article class="lb-box">
                    <p class="is-family-secondary is-size-4">Javier</p>
                    <!--p class="has-text-grey">Escuela</p-->
                    <p class="has-text-black pt-4">
                        "Yo he creado una colección para trabajar la historia a
                        partir de los cambios de nuestro entorno; comparación de
                        fotos antiguas con nuevas etc."
                    </p>
                </article>
            </div>
            <div class="column is-3">
                <article class="lb-box">
                    <p class="is-family-secondary is-size-4">Ana</p>
                    <!--p class="has-text-grey">Escuela</p-->
                    <p class="has-text-black pt-4">
                        "Ha sido muy útil para crear actividades de evaluación
                        de la asignatura mediante los juegos de preguntas."
                    </p>
                </article>
            </div>
            <div class="column is-3">
                <article class="lb-box">
                    <p class="is-family-secondary is-size-4">Carla</p>
                    <!--p class="has-text-grey">Escuela</p-->
                    <p class="has-text-black pt-4">
                        "Lo que me ha parecido más impresionante de esta
                        herramienta es la facilidad con la que he podido crear
                        un juego de preguntas alrededor del colegio para mis
                        alumnos."
                    </p>
                </article>
            </div>
        </div>
    </section>
</template>

<script>
export default {};
</script>

<style></style>
